export default "__VITE_ASSET__DYfYa0wl__"